import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { Typography } from "../Typography";
import styled from "@emotion/styled";
import { EcologiTheme } from "../theme";
import { css } from "@emotion/react";
import { StripeError } from "./StripeElements";
import {
  BackgroundColourMapper,
  LabelWrapper,
} from "../TextField/TextField.styles";
import { InputVariantTypes } from "@ecologi/shared";

type StripeInputStylesProps = {
  theme: EcologiTheme;
  isError: false | StripeError;
  variant: InputVariantTypes;
};

export const LabelWrap = styled(LabelWrapper)`
  width: 100%;
`;
export const StripeInputStyles = ({
  theme,
  isError,
  variant,
}: StripeInputStylesProps) => css`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 48px;
  > div {
    width: 100%;
  }

  margin-top: 0px;
  margin-bottom: 8px;
  padding: 10px 16px;
  cursor: text;
  font-size: 16px;
  font-weight: 400;
  line-height: 2.4rem;
  text-transform: none;
  letter-spacing: normal;
  background-color: ${variant
    ? BackgroundColourMapper[variant]
    : BackgroundColourMapper.DEFAULT};

  border: 2px solid ${isError ? theme.colors.scarlet : "transparent"};
  border-bottom: 2px solid
    ${isError ? theme.colors.scarlet : theme.colors.cloudDarker};

  &::-webkit-input-placeholder {
    font-size: 18px;
  }

  &:focus {
    border: solid 2px ${theme.colors.night};
    outline: none;
  }

  &:after {
    border: solid 2px ${theme.colors.night};
    outline: none;
  }
`;

export const HelpWrapper = styled.div<{ showTooltip: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: ${({ theme, showTooltip }) =>
    showTooltip ? theme.colors.charcoal : theme.colors.mist};

  &:hover {
    background: ${({ theme }) => theme.colors.charcoal};
    p {
      color: ${({ theme }) => theme.colors.snowdrop};
    }
  }

  width: 19px;
  height: 19px;
  border-radius: 100%;
  cursor: pointer;
`;

export const HelpIcon = styled(Typography)<{ showTooltip: boolean }>`
  color: ${({ theme, showTooltip }) =>
    showTooltip ? theme.colors.snowdrop : theme.colors.charcoal};
`;

export const HelpTooltip = styled.div<{ showTooltip: boolean }>`
  display: ${({ showTooltip }) => (showTooltip ? "flex" : "none")};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.snowdrop};
  width: 209px;
  height: 82px;
  padding: 0px 14px 0px 18px;
  border: 2px solid ${({ theme }) => theme.colors.charcoal};
  position: absolute;
  left: -221px;
  top: -32px;
  z-index: 999;

  &:before {
    content: "";
    display: block;
    position: absolute;
    right: -14px;
    top: calc(70px / 2);
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: ${({ theme }) => theme.colors.charcoal};
    transform: rotate(90deg);
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    right: -11px;
    top: calc(70px / 2);
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: ${({ theme }) => theme.colors.snowdrop};
    transform: rotate(90deg);
  }
`;

export const HelpTooltipText = styled(Typography)`
  max-width: 93px;
  font-size: 12px !important;
  color: ${({ theme }) => theme.colors.charcoal};
`;

type StripeCardInputProps = {
  isError: false | StripeError;
  variant: InputVariantTypes;
};

export const StripeCardNumberInput = styled(
  CardNumberElement
)<StripeCardInputProps>`
  ${StripeInputStyles}
`;
export const StripeCardExpiryInput = styled(
  CardExpiryElement
)<StripeCardInputProps>`
  ${StripeInputStyles}
`;
export const StripeCardCvcInput = styled(CardCvcElement)<StripeCardInputProps>`
  ${StripeInputStyles}
`;
